
import { INVOICEINTEGRATOR_REQUEST, INVOICEINTEGRATOR_SUCCESS,INVOICEINTEGRATOR_FAILURE, UPDATE_INVOICEINTEGRATOR_REQUEST, UPDATE_INVOICEINTEGRATOR_SUCCESS, UPDATE_INVOICEINTEGRATOR_FAILURE } from './actionTypes';
import { ADD_MARKETPLACES_REQUEST, ADD_MARKETPLACES_SUCCESS, ADD_MARKETPLACES_FAILURE } from './actionTypes';

import { INVOICEINTEGRATOR_ACCOUNT_REQUEST,INVOICEINTEGRATOR_ACCOUNT_SUCCESS,INVOICEINTEGRATOR_ACCOUNT_FAILURE } from './actionTypes';
import invoiceIntegratorService from '../../services/invoiceIntegrator';


export const InvoiceIntegratorRequest = () => ({
  type: INVOICEINTEGRATOR_REQUEST,
});

export const InvoiceIntegratorSuccess = (user) => ({
  type: INVOICEINTEGRATOR_SUCCESS,
  payload: user,
});

export const InvoiceIntegratorFailure = (error) => ({
  type:INVOICEINTEGRATOR_FAILURE,
  payload: error,
});
export const getInvoiceIntegrators = (token) => {

  return async (dispatch) => {
    dispatch(InvoiceIntegratorRequest());
    try {

      const response = await invoiceIntegratorService.getInvoiceIntegratorApi(token);
      dispatch(InvoiceIntegratorSuccess(response.data));
      return response.data;
      
    } catch (error) {
      dispatch(InvoiceIntegratorFailure(error.response?.data || 'mağzalar bulunamadı!'));
      throw error;
    }
  };
};




export const addMarketPlacesRequest = () => ({
  type: ADD_MARKETPLACES_REQUEST,
});

export const addMarketPlacesSuccess = (user) => ({
  type: ADD_MARKETPLACES_SUCCESS,
  payload: user,
});

export const addMarketPlacesFailure = (error) => ({
  type: ADD_MARKETPLACES_FAILURE,
  payload: error,
});
export const addInvoiceIntegratorsAccount = (data,token) => {

  return async (dispatch) => {
    dispatch(addMarketPlacesRequest());
    try {
      const response = await invoiceIntegratorService.addInvoiceIntegratorApi(data,token);
      dispatch(addMarketPlacesSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(addMarketPlacesFailure(error.response?.data || 'MAĞZA BİLGİLERİ EKLENEMEDİ!'));
      throw error;
    }
  };
  
};



export const InvoiceIntegratorsAccountRequest = () => ({
  type: INVOICEINTEGRATOR_ACCOUNT_REQUEST,
});

export const InvoiceIntegratorsAccountSuccess = (user) => ({
  type: INVOICEINTEGRATOR_ACCOUNT_SUCCESS,
  payload: user,
});

export const InvoiceIntegratorsAccountFailure = (error) => ({
  type: INVOICEINTEGRATOR_ACCOUNT_FAILURE,
  payload: error,
});
export const getInvoiceIntegratorsAccounts = (id,token) => {

  return async (dispatch) => {
    dispatch(InvoiceIntegratorsAccountRequest());
    try {
      const response = await invoiceIntegratorService.getInvoiceIntegratorAccountsApi(id,token);
      dispatch(InvoiceIntegratorsAccountSuccess(response.data?.data));
      return response.data?.data;
    } catch (error) {
      dispatch(InvoiceIntegratorsAccountFailure(error.response?.data || 'Mağza bilgileri bulunamadı!'));
      throw error;
    }
  };
  
};


export const updateInvoiceIntegratorsRequest = () => ({
  type: UPDATE_INVOICEINTEGRATOR_REQUEST,
});

export const updateInvoiceIntegratorsSuccess = (user) => ({
  type: UPDATE_INVOICEINTEGRATOR_SUCCESS,
  payload: user,
});

export const updateInvoiceIntegratorsFailure = (error) => ({
  type: UPDATE_INVOICEINTEGRATOR_FAILURE,
  payload: error,
});
export const updateInvoiceIntegratorsAccount = (data,token) => {

  return async (dispatch) => {
    dispatch(updateInvoiceIntegratorsRequest());
    try {
      const response = await invoiceIntegratorService.updateInvoiceIntegratorApi(data,token);
      dispatch(updateInvoiceIntegratorsSuccess(response.data));
      return response.data;
    } catch (error) {
      dispatch(updateInvoiceIntegratorsFailure(error.response?.data || 'MAĞZA BİLGİLERİ güncellenemedi!'));
      throw error;
    }
  };
  
};